import Navbar from './Navbar'
import './styles.css'
import { useEffect, useState } from 'react'
import { IUrlWithOptions } from '../model/IUrlWithOption'
import ENDPOINT_CONFIG from '../../../configs/EndpointAPIs'
import { ICreateOrderReq, IEstimateFeeReq, IPath } from '../model/ahamove/UrlRequestParam'
import { ESTIMATE_FEE_DATA, INIT_TOAST, ORDER_ONCE_PATH_DATA, PRODUCT_COLUMNS_WITHOUT_ACTION } from '../experiment/data/fake-data/NaglogData'
import { IOrders, Orders } from '../model/naglog/IOrdes'
import { PAYMENT_METHOD_DATA, SERVICE_TYPES_DATA } from '../experiment/data/fake-data/AhamoveData'
import { IPaymentMethod, PaymentMethodEnum } from '../model/ahamove/FormTemplate'
import { IToast, ToastEnum } from '../model/naglog/IToast'
import ToastComponent from './order/ToastComponent'
import PathsComponent from './order/PathsComponent'
import { PathsEventEnum } from '../model/naglog/IPaths'
import EstimateFeeComponent from './order/EstimateFeeComponent'
import { ICreateOrderRes, IEstimateFeeRes } from '../model/ahamove/UrlResponseData'
import { IProduct } from '../model/wms/IProduct'
import TableBasic from '../experiment/table/table-basic/TableBasic'

// static
const AHAMOVE_URL = process.env.REACT_APP_AHAMOVE_PARTNER_PORTAL_API
const ESTIMATE_FEE_END_POINT = ENDPOINT_CONFIG.masterData.estimateFree
const CREATE_ORDER_END_POINT = ENDPOINT_CONFIG.order.create
const URL_ESTIMATE_FEE = new URL(`${AHAMOVE_URL}${ESTIMATE_FEE_END_POINT}`)
const URL_CREATE_ORDER = new URL(`${AHAMOVE_URL}${CREATE_ORDER_END_POINT}`)
// field
const estimateFeeUrlReq: IUrlWithOptions = { url: URL_ESTIMATE_FEE, option: { method: 'POST', redirect: 'follow', headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Cache-Control': 'no-cache', } } }
const createOrderUrlReq: IUrlWithOptions = { url: URL_CREATE_ORDER, option: { method: 'POST', redirect: 'follow', headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'accept': 'application/json', } } }


export default function OrdersComponent() {

  const [frm, setFrm] = useState<Orders>(ORDER_ONCE_PATH_DATA)
  const [estimateFeeData, setEstimateFeeData] = useState<IEstimateFeeRes>(ESTIMATE_FEE_DATA)
  // message
  const [toastMessage, setToastMessage] = useState<IToast>(INIT_TOAST)


  useEffect(() => {
    if (frm.Form.service_id || frm.Form.date || frm.Form.time || frm.Form.is_order_now) {
      loadEstimateFee()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [frm.Form.service_id, frm.Form.date, frm.Form.time, frm.Form.is_order_now])

  // submit


  // field template
  const [serviceTypesOptionTemp] = useState(() => SERVICE_TYPES_DATA
    .map((item: { _id: string, name_vi_vn: string }, index: number) => {
      return <option key={++index} value={item._id}>{item.name_vi_vn}</option>
    }))
  const [paymentOptionTemp] = useState(() => {
    return PAYMENT_METHOD_DATA ? PAYMENT_METHOD_DATA.map((item: IPaymentMethod, index: number) => {
      return <option key={++index} value={item.payment}>{item.description} ({item.description_vi_vn})</option>
    }) : null
  })

  const handleAddPath = () => {
    let receiverPath = frm.Form.path
    let length = receiverPath?.length || 0
    let level = length
    let updateForm: Orders = new Orders(frm.Form)
    let newPath: IPath = { name: '', mobile: '', address: '', level: level }
    updateForm.Form.path.push(newPath)

    setFrm(updateForm)
  }

  const setIsLoadingFeeState = (state: boolean) => {
    let updateData = { ...frm.Form }
    updateData.action.is_loading_fee = state
    const updatedFrm = new Orders(updateData)
    setFrm(updatedFrm)
  }
  const setIsSubmitingState = (state: boolean) => {
    let updateData = { ...frm.Form }
    updateData.action.is_sending = state
    const updatedFrm = new Orders(updateData)
    setFrm(updatedFrm)
  }

  const loadEstimateFee = () => {
    if (frm.Form.action.can_estimate_fee) {
      setIsLoadingFeeState(true)
      let path: IPath[] = frm.Form.path
      let estimateFeeParamReq: IEstimateFeeReq = {
        token: process.env.REACT_APP_TOKEN_STG as string,
        path: JSON.stringify(path),
        order_time: frm.orderTime().toString(),
        service_id: frm.Form.service_id as string
      }
      let urlEncode = new URLSearchParams(estimateFeeParamReq)
      setEstimateFeeData({ ...estimateFeeData, ...{ is_loading: true } })
      estimateFeeUrlReq.option.body = urlEncode
      fetch(estimateFeeUrlReq.url, estimateFeeUrlReq.option)
        .then((res) => res.json())
        .then((data: IEstimateFeeRes) => {
          setIsLoadingFeeState(false)
          setEstimateFeeData({ ...data, ...{ is_loading: false } })
        })
        .catch((error) => {
          console.error(`Error fetching data from ${estimateFeeUrlReq.url}:`, error)
        })
    }
  }
  const handleLoadFee = () => {
    let updateToastMessge = {}
    switch (true) {
      case !frm.Form.service_id:
        updateToastMessge = { isShow: true, type: ToastEnum.WARNING, body: 'service_id is invalid', title: ToastEnum.WARNING.toString() }
        setToastMessage({ ...toastMessage, ...updateToastMessge })
        break
      case !frm.Form.date:
        updateToastMessge = { isShow: true, type: ToastEnum.WARNING, body: 'date is invalid', title: ToastEnum.WARNING.toString() }
        setToastMessage({ ...toastMessage, ...updateToastMessge })
        break
      case !frm.Form.time:
        updateToastMessge = { isShow: true, type: ToastEnum.WARNING, body: 'time is invalid', title: ToastEnum.WARNING.toString() }
        setToastMessage({ ...toastMessage, ...updateToastMessge })
        break
      default:
        loadEstimateFee()
        break
    }
  }
  const handleCloseToast = () => {
    let closeToast = { isShow: false }
    setToastMessage({ ...toastMessage, ...closeToast })
  }

  const handleChange = (event: any) => {
    let props = event.target.getAttribute('attr-props')
    let value = event.target.value
    let inputs = { [props]: value }
    let updateData = { ...frm.Form, ...inputs } as IOrders
    const updatedFrm = new Orders(updateData)

    switch (props) {
      case 'is_order_now':
        setIsOrderNowStatus(!frm.Form.is_order_now)
        break
      case 'service_id':
      case 'date':
      case 'time':
        updatedFrm.Form.action.can_estimate_fee = value ? true : false
        setFrm(updatedFrm)
        break
      default:
        setFrm(updatedFrm)
        break
    }
  }


  const setIsOrderNowStatus = (state: boolean) => {
    let updateData = { ...frm.Form }
    updateData.is_order_now = state
    const updatedFrm = new Orders(updateData)
    setFrm(updatedFrm)
  }
  const handleUpdatePath = (event: any, type: PathsEventEnum, index: number) => {
    let updatePath: any
    switch (type) {
      case PathsEventEnum.REMOVE:
        let deleteRemainPath = new Orders(frm.Form)
        let pathData = deleteRemainPath.Form.path
        pathData.splice(index, 1)
        updatePath = pathData.map((obj, index) => (index !== 0 ? { ...obj, ...{ level: ++index } } : obj))
        deleteRemainPath.Form.path = updatePath
        setFrm(deleteRemainPath)
        break
      case PathsEventEnum.CHANGE:
        const props = event.target.getAttribute('attr-props')
        const value = event.target.value
        let inputs = { [props]: value }
        updatePath = { ...frm.Form.path[index] }
        updatePath = { ...updatePath, ...inputs } as IPath

        let updateData = { ...frm.Form } as IOrders
        updateData.path[index] = updatePath
        const updatedFrm = new Orders(updateData)
        setFrm(updatedFrm)
        break
      case PathsEventEnum.ITEMS:
        let updateItemsPathData = { ...frm.Form } as IOrders
        updateItemsPathData.items = event
        const updatedItemsFrm = new Orders(updateItemsPathData)
        setFrm(updatedItemsFrm)

        break
      default:
        break
    }

  }

  const handleSubmit = (event: { preventDefault: () => void }) => {
    event.preventDefault()
    alert('kiem tra noi dung truoc')
    console.log(frm.Form)

    // return

    if (true) {
      let path: IPath[] = frm.Form.path
      let items: IProduct[] = frm.Form.items as IProduct[]
      let orderTime = frm.Form.is_order_now ? '0' : frm.orderTime().toString()
      let createOrderParamReq: ICreateOrderReq = {
        token: process.env.REACT_APP_TOKEN_STG as string,
        path: JSON.stringify(path),
        items: JSON.stringify(items),
        order_time: orderTime,
        service_id: frm.Form.service_id as string,
        payment_method: frm.Form.payment_method as PaymentMethodEnum,
        remarks: frm.Form.remarks ?? ''
      }
      let urlEncode = new URLSearchParams(createOrderParamReq)
      createOrderUrlReq.option.body = urlEncode
      setIsSubmitingState(true)
      fetch(createOrderUrlReq.url, createOrderUrlReq.option)
        .then((res) => res.json())
        .then((data: ICreateOrderRes) => {
          setIsSubmitingState(false)
          window.location.href = data.shared_link
        })
        .catch((error) => {
          console.error(`Error fetching data from ${createOrderUrlReq.url}:`, error)
        })
    }
  }

  // render
  return (
    <div>
      <Navbar />
      <main className='container-md main-content fs-root'>
        <h4>create new order</h4>
        <form onSubmit={handleSubmit}>
          {/* accordion */}
          <div className='accordion accordion-flush border' id='accordion-panelsStayOpen'>
            {/* path */}
            <div className='accordion-item'>
              <h5 className='accordion-header' id='panelsStayOpen-headingPath'>
                <button className='accordion-button p-1 bg-success bg-gradient text-light' type='button' data-bs-toggle='collapse' data-bs-target='#panelsStayOpen-collapsePath' aria-expanded='true' aria-controls='panelsStayOpen-collapsePath'>
                  path
                </button>
              </h5>
              <div id='panelsStayOpen-collapsePath' className='accordion-collapse collapse show' aria-labelledby='panelsStayOpen-headingPath'>
                <div className='accordion-body py-0'>
                  {/* service */}
                  <div className='row align-items-center'>
                    <label className='text-nowrap col-2'>service type:</label>
                    <div className='p-1 col-auto'>
                      <select id='service-type-id' name='service-type-name' value={frm.Form.service_id} onChange={handleChange} attr-props='service_id'>
                        <option key={''} value=''>-</option>
                        {serviceTypesOptionTemp}
                      </select>
                    </div>
                  </div>

                  {/* sender && receiver */}

                  <PathsComponent data_source={frm.Form.path} updatePath={handleUpdatePath}></PathsComponent>

                  <div className='row align-items-center'>
                    <div className='col-2 my-2'>
                      <button type='button' onClick={handleAddPath}>add path</button>
                      <span className='mx-1'></span>
                      <button type='button' onClick={handleLoadFee} disabled={frm.Form.action.is_loading_fee}>load fee</button>
                    </div>
                  </div>

                </div>
              </div>
            </div>

            {/* shipment details */}
            <div className='accordion-item'>
              <h5 className='accordion-header' id='panelsStayOpen-headingShipmentDetails'>
                <button className='accordion-button p-1 bg-success bg-gradient text-light' type='button' data-bs-toggle='collapse' data-bs-target='#panelsStayOpen-collapseShipmentDetails' aria-expanded='true' aria-controls='panelsStayOpen-collapseShipmentDetails'>
                  shipment details
                </button>
              </h5>
              <div id='panelsStayOpen-collapseShipmentDetails' className='accordion-collapse collapse show' aria-labelledby='panelsStayOpen-headingShipmentDetails'>
                <div className='accordion-body py-0'>
                  {/* order time */}
                  <div className='row align-items-center'>
                    <label className='text-nowrap col-2'>order time:</label>
                    <div className='p-1 col-auto'><input type='date' id='date-id' name='date-name' value={frm.Form.date} onChange={handleChange} disabled={frm.Form.is_order_now} attr-props='date' /></div>
                    <div className='p-1 col-auto'><input type='time' id='time-id' name='time-name' value={frm.Form.time} onChange={handleChange} disabled={frm.Form.is_order_now} attr-props='time' /></div>
                    {/* order now */}
                    <div className='p-1 col-auto'><label>order now</label></div>
                    <div className='p-1 col-auto'>
                      <div className='d-flex align-items-center p-0'>
                        <input className='ms-1' type='checkbox' id='order-now-id' name='order-now-name' value={frm.Form.is_order_now?.toString()} onChange={handleChange} attr-props='is_order_now' />
                      </div>
                    </div>
                  </div>
                  {/* remarks (chú thích) */}
                  <div className='row align-items-start'>
                    <label className='text-nowrap col-2'>remarks:</label>
                    <div className='p-1 col'><textarea id='remarks-id' name='remarks-name' value={frm.Form.remarks} rows={2} cols={50} onChange={handleChange} attr-props='remarks' /></div>
                  </div>
                  {/* payment method */}
                  <div className='row align-items-center'>
                    <label className='text-nowrap col-2'>payment method:</label>
                    <div className='p-1 col-auto'>
                      <select id='payment-method-id' name='payment-method-name' value={frm.Form.payment_method} onChange={handleChange} attr-props='payment_method' >
                        <option key={''} value=''>-</option>
                        {paymentOptionTemp}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* product list */}
            <div className='accordion-item'>
              <h5 className='accordion-header' id='panelsStayOpen-headingProductList'>
                <button className='accordion-button p-1 bg-success bg-gradient text-light' type='button' data-bs-toggle='collapse' data-bs-target='#panelsStayOpen-collapseProductList' aria-expanded='true' aria-controls='panelsStayOpen-collapseProductList'>
                  product list
                </button>
              </h5>
              <div id='panelsStayOpen-collapseProductList' className='accordion-collapse collapse show' aria-labelledby='panelsStayOpen-headingProductList'>
                <div className='accordion-body py-0'>
                  <TableBasic id='merge-products-id' columns={PRODUCT_COLUMNS_WITHOUT_ACTION} fetchData={frm.Form.items ?? []} />
                </div>
              </div>
            </div>
            {/* Estimated fee */}
            <div className='accordion-item'>
              <h5 className='accordion-header' id='panelsStayOpen-headingEstimatedFee'>
                <button className='accordion-button p-1 bg-success bg-gradient text-light' type='button' data-bs-toggle='collapse' data-bs-target='#panelsStayOpen-collapseEstimatedFee' aria-expanded='true' aria-controls='panelsStayOpen-collapseEstimatedFee'>
                  estimated fee
                </button>
              </h5>
              <div id='panelsStayOpen-collapseEstimatedFee' className='accordion-collapse collapse show' aria-labelledby='panelsStayOpen-headingEstimatedFee'>
                <div className='accordion-body py-0'>
                  <EstimateFeeComponent data_view={frm.Form.path} show={frm.Form.action.can_estimate_fee} fetch_data={estimateFeeData}></EstimateFeeComponent>
                </div>
              </div>
            </div>
            <input className='mx-3 my-2' type='submit' value='Submit' disabled={frm.Form.action.is_sending} />
          </div>
        </form>
      </main>
      {/* push message */}
      <ToastComponent isShow={toastMessage.isShow} title={toastMessage.title} body={toastMessage.body} position={toastMessage.position} type={toastMessage.type} handleClose={handleCloseToast} />
    </div >
  )

}